import * as ActionType from '../../constants/actionType';

export const setSessionUser = (user) => ({type: ActionType.SET_SESSION_USER, user});

export const setSessionId = (id) => ({type: ActionType.SET_SESSION_ID, id});

export const resetSessionState = () => ({type: ActionType.RESET_SESSION_STATE});
